const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const PHASES = [
  { label: "Land Preparation", months: [3, 4], desc: "Field levelling & puddling" },
  { label: "Nursery Sowing", months: [4, 5], desc: "Seedbeds raised across Punjab & Sindh" },
  { label: "Transplanting", months: [5, 6], desc: "Seedlings moved to flooded paddies" },
  { label: "Growing Season", months: [6, 7, 8], desc: "Monsoon-fed vegetative growth" },
  { label: "Harvest", months: [9, 10], desc: "Basmati peaks late Oct – Nov" },
  { label: "Milling & Export", months: [10, 11, 0, 1], desc: "Aging, milling & fresh-crop shipments" },
];

export default function CropCalendar() {
  const currentMonth = new Date().getMonth();

  return (
    <section data-testid="crop-calendar" className="border-t border-border">
      <div className="max-w-[1480px] mx-auto px-6 md:px-10 py-20">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
          <div>
            <div className="overline">Rice Crop Cycle · Pakistan</div>
            <h2 className="mt-4 font-serif text-4xl md:text-6xl tracking-tight">
              When rice is sown<br />and harvested.
            </h2>
          </div>
          <p className="text-sm text-foreground/70 leading-relaxed max-w-sm">
            Average Kharif-season rice calendar for Punjab and Sindh. Fresh-crop availability begins right after harvest — plan your orders accordingly.
          </p>
        </div>

        <div className="mt-14 overflow-x-auto">
          <div className="min-w-[860px] border border-border">
            {/* Month headers */}
            <div className="grid grid-cols-[180px_repeat(12,1fr)] border-b border-border bg-[#0A0909]">
              <div className="p-4 font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground border-r border-border">
                Phase
              </div>
              {MONTHS.map((m, i) => (
                <div
                  key={m}
                  data-testid={`calendar-month-${m.toLowerCase()}`}
                  className={`p-4 text-center font-mono text-[10px] uppercase tracking-[0.15em] ${
                    i === currentMonth ? "text-[#3FD97A] bg-[#3FD97A]/10" : "text-muted-foreground"
                  }`}
                >
                  {m}
                </div>
              ))}
            </div>

            {/* Phase rows */}
            {PHASES.map((phase, pi) => (
              <div
                key={phase.label}
                data-testid={`calendar-phase-${pi}`}
                className={`grid grid-cols-[180px_repeat(12,1fr)] ${pi !== PHASES.length - 1 ? "border-b border-border" : ""} bg-[#0A0909] hover:bg-[#141212] transition-colors group`}
              >
                <div className="p-4 border-r border-border">
                  <div className="font-serif text-base leading-tight">{phase.label}</div>
                  <div className="mt-1 font-mono text-[9px] uppercase tracking-[0.12em] text-muted-foreground leading-relaxed">
                    {phase.desc}
                  </div>
                </div>
                {MONTHS.map((m, mi) => {
                  const active = phase.months.includes(mi);
                  const isCurrent = mi === currentMonth;
                  return (
                    <div
                      key={m}
                      className={`relative min-h-[56px] ${isCurrent ? "bg-[#3FD97A]/5" : ""}`}
                    >
                      {active && (
                        <div className="absolute inset-y-3 inset-x-1 bg-[#3FD97A]/25 border border-[#3FD97A]/60 group-hover:bg-[#3FD97A]/40 transition-colors" />
                      )}
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
        </div>

        <div className="mt-6 flex flex-wrap items-center gap-6">
          <div className="flex items-center gap-2">
            <span className="inline-block w-4 h-3 bg-[#3FD97A]/25 border border-[#3FD97A]/60" />
            <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">Active phase</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="inline-block w-4 h-3 bg-[#3FD97A]/10 border border-border" />
            <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">Current month — {MONTHS[currentMonth]}</span>
          </div>
        </div>
      </div>
    </section>
  );
}
